import { IMAncillaryContent } from '../types'
import { INoteNode } from '../../../components/ingestion/IngestedTree'
import { createUnorderedList, getListHtmls } from '../../html_utility'
import { IM360Parser } from './IM360Parser'
import { parseHtmlString } from '../../nodeCreationHelpers'

export function ordinalTitle({
  title,
  ordinal_title,
}: {
  title: string
  ordinal_title: string
}) {
  return `${ordinal_title}: ${title}`
}

export function filteredNoteNodes(...noteData: [string, string | undefined][]) {
  return noteData.reduce<INoteNode[]>((acc, [title, value]) => {
    if (value) {
      acc.push(
        IM360Parser.getInstance().createNoteNode({
          title,
          value,
          studentFacing: false,
        }),
      )
    }
    return acc
  }, [])
}

export function parseLearningGoals(acillaryContent?: IMAncillaryContent) {
  const learningGoalsValues = (acillaryContent?.goals ?? []).map(
    ({ title }) => title,
  )
  const learningGoalsValue = learningGoalsValues.length
    ? createUnorderedList(learningGoalsValues)
    : ''
  return learningGoalsValue
    ? [
        IM360Parser.getInstance().createNoteNode({
          title: 'Learning Goals',
          value: learningGoalsValue,
          studentFacing: false,
        }),
      ]
    : []
}

export function getMultiParts(htmlString: string) {
  const contentDoc = parseHtmlString(htmlString)

  const questionList = contentDoc.getElementsByTagName('ol').item(0)
  if (questionList) {
    questionList.parentElement!.removeChild(questionList)
    const parts = getListHtmls(questionList)
    const metaContent = contentDoc.body.innerHTML
    return {
      parts,
      metaContent,
    }
  }

  const pElements = contentDoc.querySelectorAll('p')
  const parts = Array.from(pElements)
    .filter((p) => {
      const text = p.textContent?.trim()
      return text && /^[a-zA-Z]\.\s*/.test(text)
    })
    .map((p) => {
      const pContent = p.textContent
      const container = p.closest('div')
      if (
        container?.textContent &&
        container.textContent.substring(0, 2) === pContent?.substring(0, 2)
      ) {
        container.parentElement!.removeChild(container)
        if (/^[a-zA-Z]\.\s*$/.test(p.textContent ?? '')) {
          p.parentElement!.removeChild(p)
        } else {
          const [, ...rest] = p.innerHTML.split('. ')
          p.innerHTML = rest.join()
        }
        return container.innerHTML.trim()
      }

      const [, ...rest] = p.innerHTML.split('. ')
      p.parentElement!.removeChild(p)
      return rest.join().trim()
    })
  if (!parts.length) {
    return
  }

  return {
    parts,
    metaContent: contentDoc.body.innerHTML,
  }
}
